// The Issue tab of the side pane: the issue a session is on, as the board
// holds it now: its key, its state, its title and its description. The
// issue's own page is one click away, and is where it is edited. Moved from
// today's Code tab (code/IssuePane.tsx there); the issue is the store's.
import { Link } from 'react-router-dom'
import type { Issue } from '../api/types'
import { Markdown } from '../markdown/Markdown'
import { StateChip } from './bits'

export function IssuePane({ issueId, issue }: { issueId: string | null; issue: Issue | undefined }) {
  if (!issueId) return <p className="code-pane-note muted">This session is on no issue.</p>
  if (!issue) return <p className="code-pane-note muted">The board holds no such issue.</p>
  return (
    <article className="code-issue">
      <p className="code-issue-top">
        {/* In its state's colour, as its chip is in a link. */}
        <span className="request-issue-key code-issue-key" data-state={issue.state}>
          {issue.key}
        </span>
        <StateChip state={issue.state} />
        <Link className="code-issue-open" to={`/${encodeURIComponent(issue.key)}`}>
          Open the issue
        </Link>
      </p>
      <h2 className="code-issue-title">{issue.title}</h2>
      {issue.description.trim() !== '' ? <Markdown source={issue.description} className="code-issue-text" /> : <p className="muted">No description yet.</p>}
    </article>
  )
}
